<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <img style="display: none;" id='reportLogo' crossorigin="Anonymous" src='https://bxi-upload-bucket.s3.ap-southeast-1.amazonaws.com/iripple-images/reports/iripple/1646293427892_report_logo.png' alt='Report Logo'>
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker @change="create_job = 0, create_job_sql = []" v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <!-- <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type == 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
         -->  
                          <!-- bryan -->
                            <div class="row">
                                <div class="col-md-7">
                                  <base-input label="Location" >
                                <a-select v-model="selectedLocation" style="width: 100%" @change="selectLocationFunction" :allowClear="true">
                                    <a-select-option v-for="option in locationOptions" :key="option.id" :value="option">{{option}}</a-select-option>
                                </a-select>
                            </base-input>
                                </div>
                            </div>
        
                            <!-- <div class="row" v-if="currentProfile == 'pos_sales_journals'">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" v-model="inputGroup">
                                            <option v-for="option in groupByOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div> -->
        
                            
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" v-model="inputSortBy">
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' > 
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                                    </button>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Status" >
                                        <select class="form-control" :disabled="this.$attrs.friendlyCode=='RECPOS'" size="large" v-model="inputStatus">
                                            <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Format" >
                                        <select class="form-control" size="large" v-model="inputFormat">
                                            <option v-for="option in formatOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row" v-if="currentProfile == 'pos_sales_journals'">
                                <div class="col-md-7"> 
                                    <base-input alternative="" label="Company">
                                        <a-select mode="multiple" v-model="inputCompanies" showSearch placeholder="All Company" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in companyOptions" :key="option.id" :value="option.id">{{option.name || option.code}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                                <div class="col-md-7"> 
                                    <base-input alternative="" label="Customer">
                                        <a-select mode="multiple" v-model="inputCustomers" showSearch placeholder="All Customers" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in customerOptions" :key="option.id" :value="option.id">{{option.name || option.code}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center text-right">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                        
                    </div>

                    <!-- <div class="row" v-if="currentProfile == 'pos_sales_journals'">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" v-model="inputGroup">
                                    <option v-for="option in groupByOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div> -->

<!--                     
                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" v-model="inputSortBy">
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' > 
                                {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                            </button>
                        </div>
                    </div> -->

                    <!-- <div class="row">
                        <div class="col-md-4">
                            <base-input label="Status" >
                                <select class="form-control" :disabled="this.$attrs.friendlyCode=='RECPOS'" size="large" v-model="inputStatus">
                                    <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div> -->
                </div>
                
            </div>
        </div>

        <div class="row">
            <div class="col-md-12" style="margin-bottom: 20px;">
                <br>
                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                </vue-json-to-csv>
                <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')" type="xlsx" class="float-right"  style=" width: 20%;">
                    <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                </download-excel>
                <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="saveDatFile">Download DAT</button> &nbsp; &nbsp;
            </div>
        </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { getReportDescription } from '../../utilities';

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                get_request: [],
                spinning: false,
                is_create_job: 0,
                create_job: 0,
                create_job_sql: [],
                create_job_params: [],
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputStatus: ((this.$attrs.friendlyCode == 'RECPOS') ? 'R' : 'P'),
                // inputGroup: '',
                // groupByOptions: [
                //     {key: '', value: 'No Grouping'},
                //     {key: 'customer', value: 'Customer'},
                // ],
                inputCustomers: [],
                customerOptions: [],
                inputCompanies: [],
                companyOptions: [],
                statusOptions: [
                    {key: 'A', value: 'Aborted'},
                    {key: 'P', value: 'Posted'},
                    {key: 'V', value: 'Voided'},
                    {key: 'R', value: 'Return'}
                ],
                formatOptions: [
                    {key: '1', value: 'Simple'},
                    {key: '2', value: 'Extended'},
                    {key: '3', value: 'Summary'},
                    {key: '4', value: 'Sales Journal'},
                    {key: '5', value: 'Summary List of Sales'}
                ],
                inputFormat: 1,
                inputSortBy: 'terminal_id',
                sortOptions: [
                    {key: 'terminal_id', value: 'Terminal'},
                    {key: 'user_id', value: 'Cashier'},
                    {key: 'document_customer_name', value: 'Customer'},
                    {key: 'trans_id', value: 'Trans ID'},
                ],
                transOptions: [
                    {key: "RELPOS", value: "POS Sales"},
                    {key: "OROPOS", value: "POS Reservations"},
                    {key: "RECPOS", value: "POS Returns"},
                ],
                inputSite: [],
                site_type: "ho",
                showSortInfo: 'asc',
                
                checkedDetailFields: ["product_id","trans_id" ,"stock_no", "barcode", "product_name", "quantity"],
                checkedHeaderFields: ["id", "document_date", "posted_at", "origin_document_id", "origin_document_date", "status"],
                
                siteOptions: [],
                birSalesReports: [],
                JsonData: [],
                accessRights: this.$attrs.access_rights,
                accessCostPriceRights: this.$attrs.access_costprice_rights,
                reportDescription: '',
                // bryan
                selectedLocation: null,
                locationOptions:[],
            }
        },
        mounted: async function () {
            var component_x = this;
            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

              // bryan
              this.siteOptions.map(({location_name}) => {
              if(this.locationOptions.length === 0 || !this.locationOptions.includes(location_name)){
                this.locationOptions = [...this.locationOptions,location_name].sort()
              }
            })
            // end

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/get_valid_customers?mode=all", null);
            component_x.customerOptions = customer;
            component_x.sort(component_x.customerOptions);

            var company = await HTTPRequest.getRequest(component_x.endPoint + "companies/get_valid_companies?mode=all", null);
            component_x.companyOptions = company;
            component_x.sort(component_x.companyOptions);

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            if(this.$attrs.friendlyCode=='RECPOS'){
                this.inputStatus = "R"
                this.statusOptions.push({key: 'R', value: 'Return'})
            } else if (this.$attrs.friendlyCode=='RELPOS'){
                this.inputStatus = ""
                this.statusOptions = [
                    // {key: 'A', value: 'Aborted'},
                    {key: 'P', value: 'Posted'},
                    {key: 'V', value: 'Voided'},
                    //{key: 'R', value: 'Return'},
                    {key: '', value: 'All'},

                ]
            } else {
                this.inputStatus = "P"
                this.statusOptions = [
                    {key: 'A', value: 'Aborted'},{key: 'P', value: 'Posted'},{key: 'V', value: 'Voided'}]
            }
            this.accessRights = this.$attrs.access_rights || []
            this.accessCostPriceRights = this.$attrs.access_costprice_rights || []
            this.reportDescription = await getReportDescription(this.currentProfile)

        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg, hdrmsg) {
                this.$notification[type]({
                    message: hdrmsg,
                    description: msg 
                });
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            monthDiff(date1,date2,roundUpFractionalMonths) {
                //Months will be calculated between start and end dates.
                //Make sure start date is less than end date.
                //But remember if the difference should be negative.
                var startDate=date1;
                var endDate=date2;
                var inverse=false;
                if(date1>date2)
                {
                    startDate=date2;
                    endDate=date1;
                    inverse=true;
                }

                //Calculate the differences between the start and end dates
                var yearsDifference=endDate.getFullYear()-startDate.getFullYear();
                var monthsDifference=endDate.getMonth()-startDate.getMonth();
                var daysDifference=endDate.getDate()-startDate.getDate();
                var monthCorrection=0;
                //If roundUpFractionalMonths is true, check if an extra month needs to be added from rounding up.
                //The difference is done by ceiling (round up), e.g. 3 months and 1 day will be 4 months.
                if(roundUpFractionalMonths===true && daysDifference>0)
                {
                    monthCorrection=1;
                }
                //If the day difference between the 2 months is negative, the last month is not a whole month.
                else if(roundUpFractionalMonths!==true && daysDifference<0)
                {
                    monthCorrection=-1;
                }

                return (inverse?-1:1)*(yearsDifference*12+monthsDifference+monthCorrection);
            },
            async createJob() {
                //Create JOB
                var jobPayload = {
                    sql: this.create_job_sql,
                    params: this.create_job_params
                }
                this.spinning= true;
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'report_job/create_job', null, jobPayload)
                if(post_request['msg'] != undefined){
                    this.openNotificationWithIcon('info', post_request['msg'], 'Create Job');
                    this.create_job = 0
                    this.create_job_sql = []
                    this.spinning= false;
                    return
                } else {
                    this.openNotificationWithIcon('error', post_request['error'], 'Create Job');
                    this.spinning= false;
                    return
                }
            },
            validateFilters: async function () {
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Date is required.', 'Generate Report');
                    this.spinning= false;
                    return
                }

                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                // let group = '';
                let customers = '';
                let companies = '';
                if(this.currentProfile == 'pos_sales_journals'){
                    // group = this.inputGroup;
                    customers = this.inputCustomers;
                    companies = this.inputCompanies;
                }
                var validate_job_params = []
                //Check if filter is greater or equal to 6 months
                this.is_create_job = 0

                if((this.monthDiff(new Date(this.inputDate[0].format('MM DD, YYYY')), new Date(this.inputDate[1].format('MM DD, YYYY')), true)) > 5){
                    this.is_create_job = 0
                    //S3 processing - disabled
                    validate_job_params = await HTTPRequest.getRequest(this.endPoint + 'report_job/validate_job?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&is_create_job=' + this.is_create_job + '&customer=' + customers, null);
                }

                if(this.inputFormat == 3 || this.inputFormat == 5){
                    this.get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_operation_report_summary?site_id=' + this.inputSite + '&current_profile=' + this.currentProfile + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&is_create_job=' + this.is_create_job + '&customer=' + customers + '&company=' + companies, null);
                } else {
                    this.get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_operation_report?site_id=' + this.inputSite + '&current_profile=' + this.currentProfile + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&is_create_job=' + this.is_create_job + '&customer=' + customers + '&company=' + companies, null);
                }

                if(validate_job_params.length > 0 && this.is_create_job == 1) {
                    if(['Q','P','X'].includes(validate_job_params[0].status) && validate_job_params[0].created_by == secureStorage.getItem("userCode")){
                        this.openNotificationWithIcon('error', 'You have already queued a report with the same filter. Please wait for the email.', 'Generate Report');
                        this.spinning= false;
                        return
                    }
                    var s3_links = JSON.parse(validate_job_params[0].s3_path)
                    this.$confirm({
                        title: 'Confirmation',
                        content: h => <div>Filter is beyond limit, this will process via jobs and automatically send the report to your registered email address.<br/> Click Create Job button to proceed. <br/><br/>Or use the existing report data with the same filter processed by <b>{validate_job_params[0].created_by} </b>last <b>{validate_job_params[0].created_at}</b>.<br/><br/><a href={s3_links.s3_pdf} class="font-weight-bold ml-1" target="_blank"><i class="fa fa-file-pdf"></i> PDF</a> | <a href={s3_links.s3_xls} class="font-weight-bold ml-1" target="_blank"><i class="fa fa-file-excel"></i> EXCEL</a> | <a href={s3_links.s3_csv} class="font-weight-bold ml-1" target="_blank"><i class="fa fa-file-csv"></i> CSV</a></div>,
                        okText: 'Create Job',
                        onOk: () => {
                                    this.create_job = true;
                                    this.create_job_sql = this.get_request
                                    this.create_job_params = {
                                        report_type: this.$attrs.friendlyCode,
                                        site_id: this.inputSite,
                                        date_from: from_date,
                                        date_to: to_date,
                                        order: this.inputSortBy,
                                        by: this.showSortInfo,
                                        status: this.inputStatus,
                                        format: this.inputFormat
                                    }
                                    this.createJob()
                                    },
                        onCancel() {}
                    });

                            this.spinning= false;
                            return
                } else if(validate_job_params.length == 0 && this.is_create_job == 1){
                    this.$confirm({
                            title: 'Confirmation',
                            content: h => <div>Filter is beyond limit, this will process via jobs and automatically send the report to your registered email address. Click Create Job button to proceed.</div>,
                            okText: 'Create Job',
                            onOk: () => {
                                    this.create_job = true;
                                    this.create_job_sql = this.get_request
                                    this.create_job_params = {
                                        report_type: this.$attrs.friendlyCode,
                                        site_id: this.inputSite,
                                        date_from: from_date,
                                        date_to: to_date,
                                        order: this.inputSortBy,
                                        by: this.showSortInfo,
                                        status: this.inputStatus,
                                        format: this.inputFormat
                                    }
                                    this.createJob()
                            },
                            onCancel() {}
                            });

                    this.spinning= false;
                    return
                }
                this.spinning= false;
            },
            generateReport: async function () {
                this.spinning= true;
                await this.validateFilters();

                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                // Format date based from sir Tom's reports format
                let formatted_from_date = this.inputDate[0].format('MMMM DD, YYYY hh:mm a'); 
                let formatted_to_date = this.inputDate[1].format('MMMM DD, YYYY hh:mm a');

                let no_subtotal = ["barcode", "stock_no", "product_name", "tax_rate", "created_at", "updated_at", "discount_text", "remarks"]
                
                var siteSpecific = this.get_request;
                //let reportLogo = document.getElementById('reportLogo');

                if(siteSpecific.length > 0 && this.inputFormat != 3){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    //doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }
                    
                    let headers = [];
                    let header_detail = [];
                    let simpleplus = 0
                    let spanplus = 0
                    if( this.inputFormat == 2 ) {
                        simpleplus = 5
                        spanplus = 1
                    }
                    header_detail.push( 
                        {content: 'Terminal', styles: {halign: 'left', valign: 'center'}},
                        {content: 'Date', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Trans #', styles: {halign: 'center', valign: 'center'}},
                        {content: 'SI #', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Customer', colSpan: 2 + spanplus, styles: {halign: 'center', valign: 'center'}},
                        {content: 'References', colSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Remarks', colSpan: 3 + spanplus, styles: {halign: 'center', valign: 'center'}}
                        )

                    headers = [header_detail]
                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            let sub_total_qty = 0
                            let sub_total_amount = 0
                            let sub_total_cost = 0
                            let sub_total_markup = 0
                            let sub_total_disc = 0
                            let sub_total_srp = 0
                            let sub_total_net_price = 0
                            let sub_total_ave_price = 0
                            let sub_cost = 0
                            let grand_total_qty = 0
                            let grand_total_amount = 0
                            let grand_total_cost = 0
                            let grand_total_markup = 0
                            let grand_total_disc = 0
                            let grand_total_srp = 0
                            let grand_total_net_price = 0
                            let grand_total_ave_price = 0
                            let grand_cost = 0
                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name
                                
                                if(grouper == 'start'){
                                    let h_detail = [
                                        {content: reportLine.terminal_name, styles: {halign: 'left', fontStyle: 'bold'}},
                                        {content: moment(String(reportLine.document_date)).format('MM/DD/YYYY hh:mm'), styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: reportLine.trans_id, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: reportLine.invoice_no, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: reportLine.document_customer_name, colSpan: 2 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: "", styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: (reportLine.reference_code1 + "").replace("null", ""), colSpan: 1, styles: {halign: 'center', fontStyle: 'bold'}},
                                        // {content: (reportLine.remark + ((Number(reportLine.is_manual) > 0) ? ' Manual Reference: ' + reportLine.manual_reference_number : '') +"").replace("null", ""), colSpan: 3 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}}
                                        {content: (reportLine.remark + ((Number(reportLine.is_manual) > 0) ? '' : '') +"").replace("null", ""), colSpan: 3 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}}
                                    ];
                                    reportData.push(Object.assign({}, h_detail))
                                    let cashier_detail = [
                                        {content: 'Cashier: ' + reportLine.cashier, colSpan: 4, styles: {halign: 'left', fontStyle: 'bold'}}
                                    ];
                                    reportData.push(Object.assign({}, cashier_detail))
                                    let detail_header = [
                                            {content: 'Product Code', styles: {halign: 'left', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Barcode', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Description', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Quantity', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Discount', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'SRP', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Net Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Ave Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Amt.', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            ];
                                            if( this.inputFormat == 2 ) {
                                                detail_header.push(
                                                    {content: 'MarkUp', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                                    {content: 'MarkUp%', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}}
                                                )
                                            }
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != grouper_name){
                                        let h_detail = [
                                            {content: reportLine.terminal_name, styles: {halign: 'left', fontStyle: 'bold'}},
                                            {content: moment(String(reportLine.document_date)).format('MM/DD/YYYY hh:mm'), styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: reportLine.trans_id, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: reportLine.invoice_no, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: reportLine.document_customer_name, colSpan: 2 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: "", styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: (reportLine.reference_code1 + "").replace("null", ""), colSpan: 1, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: (reportLine.remark + "").replace("null", ""), colSpan: 3 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}}
                                        ];
                                        reportData.push(Object.assign({}, h_detail))
                                        let cashier_detail = [
                                            {content: 'Cashier: ' + reportLine.cashier, colSpan: 4, styles: {halign: 'left', fontStyle: 'bold'}}
                                        ];
                                        reportData.push(Object.assign({}, cashier_detail))
                                        let detail_header = [
                                            {content: 'Product Code', styles: {halign: 'left', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Barcode', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Description', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Quantity', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Discount', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'SRP', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Net Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Ave Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Amt.', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            ];
                                            if( this.inputFormat == 2 ) {
                                                detail_header.push(
                                                    {content: 'MarkUp', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                                    {content: 'MarkUp%', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}}
                                                )
                                            }
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = grouper_name

                                    let detail = [
                                        reportLine.product_id,
                                        reportLine.barcode,
                                        reportLine.product_name,
                                        this.convertToCurrency(Number(reportLine.quantity)),
                                        this.convertToCurrency(Number(reportLine.discount)),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.original_price)), 'Y'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.price)), 'Y'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.subtotal / reportLine.quantity)),'Y'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.price * reportLine.quantity)-Number(reportLine.discount)), 'Y'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost * reportLine.quantity)), 'Z')
                                    ]

                                let markup_display = 0
                                let markup_percent_display = 0
                                if(this.inputFormat == '2'){
                        
                                    markup_display = Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)

                                    if( Number(reportLine.cost * reportLine.quantity) != 0)
                                        markup_percent_display = (markup_display / Number(reportLine.cost * reportLine.quantity)) * 100
                                    else 
                                        markup_percent_display = Number(0)
                                    
                                    detail.push(
                                        this.convertToCurrency(Number(markup_display)),
                                        this.convertToCurrency(Number(markup_percent_display))
                                    )     
                                }

                                sub_total_qty += Number(reportLine.quantity)
                                sub_total_amount += Number(reportLine.price * reportLine.quantity)-Number(reportLine.discount)
                                sub_total_cost += Number(reportLine.cost * reportLine.quantity)
                                sub_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                sub_total_disc += Number(reportLine.discount)
                                sub_total_srp += Number(reportLine.original_price)
                                sub_total_net_price += Number(reportLine.price)
                                sub_total_ave_price += Number(reportLine.subtotal) / Number(reportLine.quantity)
                                sub_cost += Number(reportLine.cost)
                                
                                grand_total_qty += Number(reportLine.quantity)
                                grand_total_amount += Number(reportLine.price * reportLine.quantity)-Number(reportLine.discount)
                                grand_total_cost += Number(reportLine.cost * reportLine.quantity)
                                grand_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                grand_total_disc += Number(reportLine.discount)
                                grand_total_srp += Number(reportLine.original_price)
                                grand_total_net_price += Number(reportLine.price)
                                grand_total_ave_price += Number(reportLine.subtotal) / Number(reportLine.quantity)
                                grand_cost += Number(reportLine.cost)

                                reportData.push(Object.assign({}, detail))
                    
                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', '', 'Sub Total :', this.convertToCurrency(Number(sub_total_qty)), '', '', '', '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_amount)), 'Y'), '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_cost)), 'Z'), ((this.inputFormat == '2') ? this.convertToCurrency(Number(sub_total_markup)) : '' )
                                        ]));
                
                                    //Grand Total
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', '', 'Grand Total :', this.convertToCurrency(Number(grand_total_qty)), '', '', '', '', this.convertToCurrency(Number(grand_total_amount)), '', this.addMaskValidation(this.convertToCurrency(Number(grand_total_cost)), 'Z'), ((this.inputFormat == '2') ? this.convertToCurrency(Number(grand_total_markup)) : '' )
                                            ]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = grouper_name
                                    next_grouper = this.birSalesReports[i+1].grouper_name

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, ['', '', 'Sub Total :', this.convertToCurrency(Number(sub_total_qty)), '', '', '', '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_amount)), 'Y'), '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_cost)), 'Z'), ((this.inputFormat == '2') ? this.convertToCurrency(Number(sub_total_markup)) : '' )
                                            ]));

                                        sub_total_qty = 0
                                        sub_total_amount = 0
                                        sub_total_cost = 0
                                        sub_total_markup = 0
                                        sub_total_disc = 0
                                        sub_total_srp = 0
                                        sub_total_net_price = 0
                                        sub_total_ave_price = 0
                                        sub_cost = 0
                                    }
                                }
                                    
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,trans_val + " Journal By " + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
    
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(340,20,site_text,"right");
                        
                        doc.text(15,25,"For the Period of " + from_date + " to " + to_date)

                        let colStyles = {}
                        colStyles = {
                            0: {cellWidth: 30},
                            1: {cellWidth: 40},
                            2: {cellWidth: 60},
                            3: {cellWidth: 25 - simpleplus},
                            4: {cellWidth: 25 - simpleplus},
                            5: {cellWidth: 25 - simpleplus},
                            6: {cellWidth: 25 - simpleplus},
                            7: {cellWidth: 25 - simpleplus},
                            8: {cellWidth: 25 - simpleplus},
                            9: {cellWidth: 25 - simpleplus},
                            10: {cellWidth: 25 - simpleplus},
                        }

                        if (this.inputFormat == '2') {
                          colStyles = {
                            ...colStyles,
                            11: {cellWidth: 18},
                            12: {cellWidth: 18}
                          }
                        }
                        
                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && data.row.raw[0] == 'Grand Total :'){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });
                    
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportUtils.pdfTools.addFooter(doc, printed_by, trans_val + " Journal By " + group_text, 340, 200, x+1, siteSpecific.length)

                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else if(this.inputFormat == 3){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    //doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }
                    
                    let headers = [];
                    let header_detail = [];
                    let simpleplus = 0
                    let spanplus = 0
                    if( this.inputFormat == 2 ) {
                        simpleplus = 5
                        spanplus = 1
                    }
                    header_detail.push( 
                        {content: 'Trans #', styles: {halign: 'left', valign: 'center'}},
                        {content: 'SI #', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Status', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Date Time', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Customer', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Type', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Reason', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Cashier', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Supervisor', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Gross Amt', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Net Amt', styles: {halign: 'center', valign: 'center'}}
                        )

                    headers = [header_detail]
                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        // filter reports based on selected site(s)
                        if (this.inputSite.length > 0) {
                            this.birSalesReports = this.birSalesReports.filter(report => this.inputSite.includes(report.site_id));
                        }

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            let grand_total_amount = 0
                            let grand_net_total_amount = 0
                            let grouper = 'start'
                            let h_detail = []
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name
                                
                                h_detail = [
                                    {content: reportLine.trans_id, styles: {halign: 'center'}},
                                    {content: reportLine.invoice_no, styles: {halign: 'center'}},
                                    {content: (reportLine.document_status === 'V') ? 'Voided' : '', styles: {halign: 'left'}},
                                    {content: moment(String(reportLine.document_date)).format('MM/DD/YYYY hh:mm a'), styles: {halign: 'center'}},
                                    {content: reportLine.customer_name, styles: {halign: 'left'}},
                                    {content: (reportLine.document_status === 'P') ? 'Sales' : (reportLine.document_status === 'V') ? 'Voided' : reportLine.document_status === 'R' ? 'Returned' : 'Aborted', styles: {halign: 'left'}},
                                    {content: reportLine.reason_name, styles: {halign: 'left'}},
                                    {content: reportLine.cashier, styles: {halign: 'left'}},
                                    {content: reportLine.approval_code || '', styles: {halign: 'left'}},
                                    {content: this.addMaskValidation(this.convertToCurrency(( (reportLine.document_status === 'V' && reportLine.document_trans_code != 'REC') || (reportLine.document_status === 'R')) ? -Number(reportLine.recom_amount_gross) : reportLine.document_status === 'A' ? 0 : Number(reportLine.recom_amount_gross)), 'Z'), styles: {halign: 'right'}},
                                    {content: this.addMaskValidation(this.convertToCurrency(( (reportLine.document_status === 'V' && reportLine.document_trans_code != 'REC') || (reportLine.document_status === 'R')) ? -Number(reportLine.amount_net) : reportLine.document_status === 'A' ? 0 : Number(reportLine.amount_net)), 'Z'), styles: {halign: 'right'}}
                                ];

                                reportData.push(Object.assign({}, h_detail))

                                grouper = grouper_name
                                if (reportLine.document_status === 'P' || (reportLine.document_status === 'V' && reportLine.document_trans_code == 'REC'))  {
                                    grand_total_amount += Number(reportLine.recom_amount_gross);
                                    grand_net_total_amount += Number(reportLine.amount_net);
                                }

                                if (reportLine.document_status === 'R' || (reportLine.document_status === 'V' && reportLine.document_trans_code != 'REC')) {
                                    grand_total_amount -= Number(reportLine.recom_amount_gross);
                                    grand_net_total_amount -= Number(reportLine.amount_net);
                                }
                                if(i == this.birSalesReports.length-1){
                                    //Sub Total and Grand Total
                                    //reportData.push(Object.assign({},['', '', '', '', '', '', '', '', 'Sub Total', this.addMaskValidation(this.convertToCurrency(Number(grand_total_amount)), 'Z')]));
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({},
                                    [
                                        '', '', '', '', '', '', '', '',
                                        this.inputStatus === 'P' ? 'Grand Total except Void Transaction' : 'Grand Total', 
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_total_amount)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_net_total_amount)), 'Z')
                                    ]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = grouper_name
                                    next_grouper = this.birSalesReports[i+1].grouper_name

                                    // if(current_grouper != next_grouper){
                                    //     grand_total_amount = 0
                                    // }
                                }
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,trans_val + " Journal Summary")
                        doc.setFontType("normal");
                        doc.setFontSize(10);

                        // loop through siteSpecific array to display site per terminal
                        let site_text = '';
                        let currentSiteNames = new Set();
                        let site_code_text = '';
                        let currentSiteCodes = new Set();
                        let currentSiteRefCodes = new Set();
                        let site_refcode_text = '';



                        for (let i = 0; i < this.birSalesReports.length; i++) {
                            let reportLine = this.birSalesReports[i];
                            let site = this.siteOptions.find(site => site.id === reportLine.site_id);
                            let siteName = site ? site.name : reportLine.site_name ? reportLine.site_name : '';
                            let siteCode = site ? site.code : "";
                            let siteRefCode = site ? site.refcode : reportLine.refcode ? reportLine.refcode : '';

                            if (!currentSiteNames.has(siteName)) {
                                currentSiteNames.add(siteName);
                                site_text += siteName + '\n';
                            }

                            if (!currentSiteCodes.has(siteCode)) {
                                currentSiteCodes.add(siteCode);
                                site_code_text += siteCode;
                            }

                            if (!currentSiteRefCodes.has(siteRefCode)) {
                                currentSiteRefCodes.add(siteRefCode);
                                site_refcode_text += siteRefCode;
                            }
                        }

                        doc.text(340, 20, site_text, "right");

                        // doc.text(15,25,"For the Period of " + from_date + " to " + to_date)
                        doc.text(15, 25, "From " + formatted_from_date + " To " + formatted_to_date);
                        doc.text(15, 30, `(All Transactions with ${site_refcode_text})`);
                        
                        let colStyles = {}
                        colStyles = {
                            0: {cellWidth: 20},
                            1: {cellWidth: 20},
                            2: {cellWidth: 20},
                            3: {cellWidth: 35},
                            4: {cellWidth: 55},
                            5: {cellWidth: 20},
                            6: {cellWidth: 30},
                            7: {cellWidth: 50},
                            8: {cellWidth: 30},
                            9: {cellWidth: 25},
                            10: {cellWidth: 25}
                        }
                        let blankRow = ['', '', '', '', '', '', '', '', '', ''];  // Empty row with the same number of columns
                        reportData.unshift(Object.assign({}, blankRow));  // Insert the blank row at the start of reportData
                        doc.setFontType("bold");
                        doc.text(15, 47, site_text);
                        doc.setFontType("normal");

                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            margin: { bottom: 20 },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && data.row.raw[0] == 'Grand Total :'){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            },
                            didDrawPage: function(data) {
                                let printed_by = secureStorage.getItem("email")
                                if(printed_by == null){
                                    printed_by = ''
                                }

                                reportUtils.pdfTools.addFooter(doc, printed_by, trans_val + " Journal Summary", 340, 200, x+1, siteSpecific.length)
                            },
                        });                 
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                
                } else if(this.is_create_job == 0) {
                    this.openNotificationWithIcon('warning', 'No data to export. Please check your filter selections.', 'Generate Report');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                await this.validateFilters();
                
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                // Format date based from sir Tom's reports format
                let formatted_from_date = this.inputDate[0].format('MMMM DD, YYYY hh:mm a'); 
                let formatted_to_date = this.inputDate[1].format('MMMM DD, YYYY hh:mm a');

                let siteSpecific = this.get_request;

                if(siteSpecific.length > 0 && this.inputFormat < 3){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let headers = ['Terminal',' Date',' Trans #',' SI #',' Customer',' References',' Remarks',' Product Code',' Barcode',' Description',' Quantity',' Discount',' SRP',' Net Price',' Average Price',' Total Amt',' Cost',' Total Cost',' MarkUp',' MarkUp%'];
                    let site_specific = [];
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let sub_total_qty = 0
                            let sub_total_amount = 0
                            let sub_total_cost = 0
                            let sub_total_markup = 0
                            let sub_total_disc = 0
                            let sub_total_srp = 0
                            let sub_total_net_price = 0
                            let sub_total_ave_price = 0
                            let sub_cost = 0
                            let grand_total_qty = 0
                            let grand_total_amount = 0
                            let grand_total_cost = 0
                            let grand_total_markup = 0
                            let grand_total_disc = 0
                            let grand_total_srp = 0
                            let grand_total_net_price = 0
                            let grand_total_ave_price = 0
                            let grand_cost = 0
                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [group_text + ' : ' + grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [group_text + ' : ' + grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let markup_display = 0
                                let markup_percent_display = 0
                                
                                markup_display = Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)

                                if( Number(reportLine.cost * reportLine.quantity) != 0)
                                    markup_percent_display = (markup_display / Number(reportLine.cost * reportLine.quantity)) * 100
                                else 
                                    markup_percent_display = Number(0)

                                let detail = [
                                    String(reportLine.terminal_name),
                                    moment(String(reportLine.document_date)).format('MM/DD/YYYY hh:mm A'),
                                    String(reportLine.trans_id),
                                    String(reportLine.invoice_no),
                                    String(reportLine.document_customer_name),
                                    (reportLine.reference_code1 + "").replace("null", ""),
                                    (reportLine.remark + "").replace("null", ""),
                                    String(reportLine.product_id),
                                    String(reportLine.barcode),
                                    String(reportLine.product_name),
                                    this.convertToCurrency(Number(reportLine.quantity)),
                                    this.convertToCurrency(Number(reportLine.discount)),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.original_price)), 'Y'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.price)), 'Y'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.subtotal / reportLine.quantity)), 'Y'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.price * reportLine.quantity) - Number(reportLine.discount)), 'Y'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost * reportLine.quantity)), 'Z'),
                                    this.convertToCurrency(Number(markup_display)),
                                    this.convertToCurrency(Number(markup_percent_display))
                                ]
                                // sub_total_qty += Number(reportLine.quantity)
                                // sub_total_amount += Number(reportLine.original_price * reportLine.quantity)
                                // sub_total_cost += Number(reportLine.cost * reportLine.quantity)
                                // sub_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                // grand_total_qty += Number(reportLine.quantity)
                                // grand_total_amount += Number(reportLine.original_price * reportLine.quantity)
                                // grand_total_cost += Number(reportLine.cost * reportLine.quantity)
                                // grand_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                sub_total_qty += Number(reportLine.quantity)
                                sub_total_amount += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.discount)
                                sub_total_cost += Number(reportLine.cost * reportLine.quantity)
                                sub_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                sub_total_disc += Number(reportLine.discount)
                                sub_total_srp += Number(reportLine.original_price)
                                sub_total_net_price += Number(reportLine.price)
                                sub_total_ave_price += Number(reportLine.subtotal) / Number(reportLine.quantity)
                                sub_cost += Number(reportLine.cost)
                                
                                grand_total_qty += Number(reportLine.quantity)
                                grand_total_amount += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.discount)
                                grand_total_cost += Number(reportLine.cost * reportLine.quantity)
                                grand_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                grand_total_disc += Number(reportLine.discount)
                                grand_total_srp += Number(reportLine.original_price)
                                grand_total_net_price += Number(reportLine.price)
                                grand_total_ave_price += Number(reportLine.subtotal) / Number(reportLine.quantity)
                                grand_cost += Number(reportLine.cost)

                                reportData.push(Object.assign({}, detail))

                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    reportData.push(Object.assign({}, ['', '', '', '', '', '', '', '', '', 'Subtotal : ', Number(sub_total_qty), '', '', '', '', this.convertToCurrency(Number(sub_total_amount)), '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_cost)), 'Z'), this.convertToCurrency(Number(sub_total_markup))
                                    ]));
                
                                    //Grand Total
                                    reportData.push(Object.assign({}, ['', '', '', '', '', '', '', '', '', 'Grand total : ', Number(grand_total_qty), '', '', '', '', this.convertToCurrency(Number(grand_total_amount)), '', this.addMaskValidation(this.convertToCurrency(Number(grand_total_cost)), 'Z'), this.convertToCurrency(Number(grand_total_markup))
                                    ]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ['', '', '', '', '', '', '', '', '', 'Subtotal : ', Number(sub_total_qty), '', '', '', '', this.convertToCurrency(Number(sub_total_amount)), '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_cost)), 'Z'), this.convertToCurrency(Number(sub_total_markup))
                                        ]));

                                        sub_total_qty = 0
                                        sub_total_amount = 0
                                        sub_total_cost = 0
                                        sub_total_markup = 0
                                        sub_total_disc = 0
                                        sub_total_srp = 0
                                        sub_total_net_price = 0
                                        sub_total_ave_price = 0
                                        sub_cost = 0
                                    }
                                }
                            }

                        }

                        let site_text = ''
                        if(this.inputSite.length == 0){
                            site_text = 'All Sites'
                        } else {
                            let sites = this.inputSite
                            for (var s = 0; s < sites.length; s++) {
                                if(s == 0){
                                    site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                } else {
                                    site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                }
                            }
                        }
                        reportData.unshift([site_text]);
                        
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        reportData.push([])
                        reportData.push([trans_val + " Journal By " + group_text, "Generated By: " + printed_by,"For the Period of " + from_date + " to " + to_date])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else if(siteSpecific.length > 0 && this.inputFormat == 3) {
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    // let doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'legal' }); // new orientation format not prio for now
                    let headers = [' Trans #',' SI #',' Status',' Date Time',' Customer',' Type',' Reason',' Cashier',' Supervisor',' Gross Amount',' Net Amount'];
                    let site_specific = [];
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        // filter reports based on selected site(s)
                        if (this.inputSite.length > 0) {
                            this.birSalesReports = this.birSalesReports.filter(report => this.inputSite.includes(report.site_id));
                        }

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let grand_total_amount = 0
                            let grand_net_total_amount = 0
                            let grouper = 'start'

                            // process each site and its terminals
                            let processedSites = new Set();
                            
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name
                                let site = this.siteOptions.find(site => site.id === reportLine.site_id);
                                let siteName = site ? site.name : reportLine.site_name ? reportLine.site_name :"";

                                // add site header only if not already processed
                                if (!processedSites.has(reportLine.site_id)) {
                                    reportData.push([`Site : ${siteName}`]);
                                    processedSites.add(reportLine.site_id);
                                }

                                // add terminal header for each new terminal group
                                if (grouper === 'start' || grouper !== reportLine.grouper_id) {
                                    reportData.push([`Terminal : ${grouper_name}`]);
                                }

                                grouper = reportLine.grouper_id;
                                let detail = [
                                    String(reportLine.trans_id),
                                    String(reportLine.invoice_no),
                                    String(reportLine.document_status === 'V' ? 'Voided' : ''),
                                    moment(String(reportLine.document_date)).format('MM/DD/YYYY hh:mm A'),
                                    String(reportLine.customer_name),
                                    String((reportLine.document_status === 'P') ? 'Sales' : (reportLine.document_status === 'V') ? 'Voided' : reportLine.document_status === 'R' ? 'Returned' : 'Aborted'),
                                    String(reportLine.reason_name),
                                    String(reportLine.cashier),
                                    String(reportLine.approval_code || ''),
                                    this.addMaskValidation(this.convertToCurrency((reportLine.document_status === 'R' || (reportLine.document_status === 'V' && reportLine.document_trans_code != 'REC')) ? -Number(reportLine.recom_amount_gross) : reportLine.document_status === 'A' ? 0 : Number(reportLine.recom_amount_gross)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency((reportLine.document_status === 'R' || (reportLine.document_status === 'V' && reportLine.document_trans_code != 'REC')) ? -Number(reportLine.amount_net) : reportLine.document_status === 'A' ? 0 : Number(reportLine.amount_net)), 'Z')
                                ]
                                if (reportLine.document_status === 'P' || (reportLine.document_status === 'V' && reportLine.document_trans_code == 'REC'))  {
                                    grand_total_amount += Number(reportLine.recom_amount_gross); 
                                    grand_net_total_amount += Number(reportLine.amount_net); 
                                }
                                if (reportLine.document_status === 'R' || (reportLine.document_status === 'V' && reportLine.document_trans_code != 'REC')) {
                                    grand_total_amount -= Number(reportLine.recom_amount_gross);
                                    grand_net_total_amount -= Number(reportLine.amount_net);
                                }
                                reportData.push(Object.assign({}, detail))

                                if(i == this.birSalesReports.length-1){
                                    //Grand Total
                                    reportData.push(Object.assign({},
                                    [
                                        '', '', '', '', '', '', '', '',
                                        this.inputStatus === 'P' ? 'Grand Total except Void Transaction: ' : 'Grand Total: ', 
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_total_amount)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_net_total_amount)), 'Z')
                                    ]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = grouper_name
                                    next_grouper = this.birSalesReports[i+1].grouper_name

                                    if(current_grouper != next_grouper){
                                        // grand_total_amount = 0
                                    }
                                }
                            }

                        }
                        
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        reportData.push([])
                        reportData.push([trans_val + " Journal Summary", "Generated By: " + printed_by, "From " + formatted_from_date + " To " + formatted_to_date]);
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);

                    if (this.JsonData.length === 0) {
                        this.openNotificationWithIcon('warning', 'No data to export. Please check your filter selections.', 'Generate Report');
                    }
                } else if(siteSpecific.length > 0 && (this.inputFormat == 4)){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let headers = [
                        'Site',
                        'Terminal',
                        'Trans Number',
                        'Date',
                        'Transaction Type',
                        'Reference/Doc No/Invoice No',
                        'Remarks',
                        'Customer TIN',
                        'Customer Name',
                        'Address',
                        'Reason Name',
                        'Barcode',
                        'Description',
                        'Quantity',
                        'Price',
                        'Gross Sales',
                        'Discount',
                        'Net Amount',
                        'Net Sales without VAT',
                        'VAT Amount',
                        'Vatable Sales',
                        'Vat-Exempt Sales',
                        'Zero Rated Sales',
                        'Store Event',
                        'Foot Traffic',
                    ];
                    let site_specific = [];
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }

                    let grand_total_amount = 0;
                    let grand_amount_due = 0;
                    let grand_amount_total_discount = 0;
                    let grand_amount_net = 0;
                    let grand_amount_tax = 0;
                    let grand_amount_gross = 0;
                    let grand_vatable_sales = 0;
                    let grand_vat_exempt = 0;
                    let grand_zero_rated = 0;

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            let amount_due = 0
                            let amount_total_discount = 0
                            let amount_net = 0
                            let amount_tax = 0
                            let amount_gross = 0
                            let vatable_sales = 0
                            let vat_exempt = 0
                            let zero_rated = 0
                            let grouper = 'start'

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                // console.log("reportLine: ", reportLine)
                    
                                let detail = [
                                    reportLine.site_name,
                                    reportLine.terminal_name,
                                    reportLine.trans_id,
                                    moment(String(reportLine.business_date)).format('MM/DD/YYYY'),
                                    String((reportLine.document_status = 'P') ? 'Invoice' : ((reportLine.document_status = 'V') ? 'Voided' : ((reportLine.document_status = 'R') ? 'Credit Memo': 'Aborted'))),
                                    String(reportLine.or_doc),
                                    //(Number(reportLine.is_manual) > 0) ? 'Manual Reference: ' + reportLine.manual_reference_number : '',
                                    (Number(reportLine.is_manual) > 0) ? '' : '',
                                    reportLine.customer_tin,
                                    reportLine.customer_name,
                                    reportLine.customer_address,
                                    reportLine.reason_name,
                                    reportLine.barcode,
                                    reportLine.product_name,
                                    reportLine.quantity,
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.price)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.amount_gross)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.amount_total_discount)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.amount_gross) - Number(reportLine.amount_total_discount)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency((Number(reportLine.amount_gross) - Number(reportLine.amount_total_discount)) - Number(reportLine.amount_tax)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.amount_tax)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.vatable_sales)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.vat_exempt)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.zero_rated)), 'Z'),
                                    reportLine.store_event,
                                    reportLine.foot_traffic,
                                ]
                                //amount_due += Number(reportLine.amount_due)
                                // amount_due += Number(reportLine.recom_amount_gross) - Number(reportLine.amount_total_discount)
                                // amount_total_discount += Number(reportLine.amount_total_discount)
                                //amount_net += Number(reportLine.amount_net)
                                // amount_net += (Number(reportLine.recom_amount_gross) - Number(reportLine.amount_total_discount)) - Number(reportLine.amount_tax)
                                // amount_tax += Number(reportLine.amount_tax)
                                // amount_gross += Number(reportLine.recom_amount_gross)

                                // accumulate totals for the current site
                                amount_due += Number(reportLine.amount_gross) - Number(reportLine.amount_total_discount);
                                amount_total_discount += Number(reportLine.amount_total_discount);
                                amount_net += (Number(reportLine.amount_gross) - Number(reportLine.amount_total_discount)) - Number(reportLine.amount_tax);
                                amount_tax += Number(reportLine.amount_tax);
                                amount_gross += Number(reportLine.amount_gross);
                                vatable_sales += Number(reportLine.vatable_sales);
                                vat_exempt += Number(reportLine.vat_exempt);
                                zero_rated += Number(reportLine.zero_rated);

                                reportData.push(Object.assign({}, detail))

                                // add the current site totals to the grand totals
                                grand_amount_due += Number(reportLine.amount_gross) - Number(reportLine.amount_total_discount);
                                grand_amount_total_discount += Number(reportLine.amount_total_discount);
                                grand_amount_net += (Number(reportLine.amount_gross) - Number(reportLine.amount_total_discount)) - Number(reportLine.amount_tax);
                                grand_amount_tax += Number(reportLine.amount_tax);
                                grand_amount_gross += Number(reportLine.amount_gross);
                                grand_vatable_sales += Number(reportLine.vatable_sales);
                                grand_vat_exempt += Number(reportLine.vat_exempt);
                                grand_zero_rated += Number(reportLine.zero_rated);

                                if (i == this.birSalesReports.length - 1 && x === siteSpecific.length - 1) {
                                    reportData.push(Object.assign({}, [
                                        'Total', '', '', '', '', '', '', '', '', '', '', '', '', '','',
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_amount_gross)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_amount_total_discount)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_amount_due)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_amount_net)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_amount_tax)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_vatable_sales)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_vat_exempt)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(grand_zero_rated)), 'Z'),
                                    ]));
                                }
                            }

                        }

                        
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        if (x == siteSpecific.length - 1) {
                            reportData.push([trans_val + " Journal By " + group_text, "Generated By: " + printed_by,"For the Period of " + from_date + " to " + to_date])
                            reportData.push([])
                        }

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);

                    if (this.JsonData.length === 0) {
                        this.openNotificationWithIcon('warning', 'No data to export. Please check your filter selections.', 'Generate Report');
                    }
                } else if(siteSpecific.length > 0 && (this.inputFormat == 5)){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let site_specific = [];
                    // let headers = [' ',' ',' ',' ',' ',' ',' ',' ',' ',' ', ' ', ' ', ' ', ' ', ' ', ' '];
                    let headers = [' Detail',' FIXED',' Tin',' Registered Name',' Last Name',' First Name',' Middle Name',' Trade Name',' Substreet Street Barangay Municipality City ZipCpde',' Exempt', ' Zero Rated', ' Vatable', ' VAT', ' RDO', ' End of Month', ' Date'];
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grand_total_amount = 0
                            let total_amount_net_non_vat = 0
                            let total_amount_net_zero_rated = 0
                            let total_amount_net_of_vat = 0
                            let total_amount_tax = 0
                            let company_tin = ""
                            let company_code = ""
                            let company_name = ""
                            let company_address = ""
                            let grouper = 'start'
                            let temp_detail = []
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                grouper = reportLine.company_code
                                if (reportLine.status != "R" && reportLine.status != "V"){
                                    let detail = ["D","S",
                                        String(reportLine.customer_tin),
                                        String(reportLine.customer_name),
                                        "-",
                                        "-",
                                        "-",
                                        "",
                                        String(reportLine.customer_address),
                                        reportLine.amount_net_non_vat,
                                        reportLine.amount_net_zero_rated,
                                        reportLine.amount_net_of_vat,
                                        reportLine.amount_tax,
                                        reportLine.company_tin,
                                        this.inputDate[1].format('MM/DD/YYYY'),
                                    ]
                                    temp_detail.push(Object.assign({}, detail))
                                    //amount_due += Number(reportLine.amount_due)
                                    total_amount_net_non_vat += Number(reportLine.amount_net_non_vat)
                                    total_amount_net_zero_rated += Number(reportLine.amount_net_zero_rated)
                                    //amount_net += Number(reportLine.amount_net)
                                    total_amount_net_of_vat += Number(reportLine.amount_net_of_vat)
                                    total_amount_tax += Number(reportLine.amount_tax)
                                }else{
                                    let detail = ["D","S",
                                        String(reportLine.customer_tin),
                                        String(reportLine.customer_name),
                                        "-",
                                        "-",
                                        "-",
                                        "",
                                        String(reportLine.customer_address),
                                        Number(reportLine.amount_net_non_vat)*-1,
                                        Number(reportLine.amount_net_zero_rated)*-1,
                                        Number(reportLine.amount_net_of_vat)*-1,
                                        Number(reportLine.amount_tax)*-1,
                                        reportLine.company_tin,
                                        this.inputDate[1].format('MM/DD/YYYY'),
                                    ]
                                    temp_detail.push(Object.assign({}, detail))
                                    total_amount_net_non_vat -= Number(reportLine.amount_net_non_vat)
                                    total_amount_net_zero_rated -= Number(reportLine.amount_net_zero_rated)
                                    total_amount_net_of_vat -= Number(reportLine.amount_net_of_vat)
                                    total_amount_tax -= Number(reportLine.amount_tax)
                                }

                                
                                if(grouper != reportLine.company_code || i == (this.birSalesReports.length-1)){
                                    let company_header = ["H","S",
                                        reportLine.company_tin,
                                        reportLine.company_code,
                                        "-",
                                        "-",
                                        "-",
                                        reportLine.company_name,
                                        reportLine.company_address,
                                        total_amount_net_non_vat.toFixed(2),
                                        total_amount_net_zero_rated.toFixed(2),
                                        total_amount_net_of_vat.toFixed(2),
                                        total_amount_tax.toFixed(2),
                                        "-",
                                        this.inputDate[1].format('MM/DD/YYYY'),
                                    ];
                                    reportData.push(Object.assign({}, company_header))
                                    
                                    reportData = [...reportData,...temp_detail]
                                    total_amount_net_non_vat = 0
                                    total_amount_net_zero_rated = 0
                                    total_amount_net_of_vat = 0
                                    total_amount_tax = 0
                                    temp_detail = []
                                }
                                console.log(reportData)
                                    console.log(temp_detail)
                                company_tin = reportLine.company_tin
                                company_code = reportLine.company_code
                                company_name = reportLine.company_name
                                company_address = reportLine.company_address

                                if(i == this.birSalesReports.length-1){
                                    //Grand Total
                                    // reportData.push(Object.assign({}, ['Total', '', '', '', '', '', '', this.addMaskValidation(this.convertToCurrency(Number(amount_due)), 'Z'), this.addMaskValidation(this.convertToCurrency(Number(amount_total_discount)), 'Z'), this.addMaskValidation(this.convertToCurrency(Number(amount_net)), 'Z'), this.addMaskValidation(this.convertToCurrency(Number(amount_tax)), 'Z'), this.addMaskValidation(this.convertToCurrency(Number(amount_gross)), 'Z')
                                    // ]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    // current_grouper = grouper_name
                                    // next_grouper = this.birSalesReports[i+1].grouper_name

                                    // if(current_grouper != next_grouper){
                                    //     amount_due = 0
                                    //     amount_total_discount = 0
                                    //     amount_net = 0
                                    //     amount_tax = 0
                                    //     amount_gross = 0
                                    // }
                                }
                            }
                        }

                        let site_text = ''
                        if(this.inputSite.length == 0){
                            site_text = 'All Sites'
                        } else {
                            let sites = this.inputSite
                            for (var s = 0; s < sites.length; s++) {
                                if(s == 0){
                                    site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                } else {
                                    site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                }
                            }
                        }
                        // reportData.unshift([site_text]);
                        
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        reportData.push(Object.assign({},[]))
                        reportData.push(Object.assign({},[trans_val + " Journal By " + group_text, "Generated By: " + printed_by,"For the Period of " + from_date + " to " + to_date]))
                        reportData.push(Object.assign({},[]))

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(reportData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);

                    if (this.JsonData.length === 0) {
                        this.openNotificationWithIcon('warning', 'No data to export. Please check your filter selections.', 'Generate Report');
                    }
                } else if(this.is_create_job == 0) {
                    this.openNotificationWithIcon('warning', 'No data to export. Please check your filter selections.', 'Generate Report');
                }
                console.log(this.inputFormat)
                this.spinning= false;
            },
            saveDatFile(){
                let data = ""
                this.JsonData.forEach(function(obj) {
                    console.log(obj)
                    const newItems = Object.entries(obj).reduce((ac, cu) => {
                    return [...ac, cu[1]];
                    }, [])
                    data+=newItems.join(",")+"\n"
                });
                const blob = new Blob([data], {type: 'text/plain'})
                const e = document.createEvent('MouseEvents'),
                a = document.createElement('a');
                a.download = this.currentProfile.replace(/_/g, '-')+'-'+this.currDate.replace(/ /g, '')+".dat";
                a.href = window.URL.createObjectURL(blob);
                a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                a.dispatchEvent(e);
                this.clearJsonData()
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            },
              // bryan
              selectLocationFunction(){
              if(this.inputSite.length !== 0){
                this.inputSite = []
              }
              this.siteOptions.map(({location_name, id}) => {
                if(location_name === this.selectedLocation){
                  this.inputSite = [...this.inputSite, id]
                }
              })
            }
        },
    };
</script>

<style></style>
